import React from 'react'
import { Button } from 'src/modules/ui'
import MessageSupplierModal from '../../messages/components/MessageSupplierModal'
import { MessageOutlined as MessageIcon } from '@material-ui/icons'
import { usePurchasing } from '../../purchasing/hooks'

import {
  useUnapproveInvoiceMutation,
  useApproveInvoiceAfterDisputeMutation,
  useMarkInvoicePaidMutation,
} from '../api'

/**
 * Determine if a button should be shown to action
 * a given status based on the current status.
 *
 * 'unapprove' and 'undispute' are actions only - the invoice will be set to 'submitted'
 *
 * See README for prop drilling reasoning
 *
 * @param {*} currentStatus the current status of the invoice
 * @param {*} intendedAction the intended action to be taken
 * @returns {boolean}
 */
const shouldShowForStatusAction = (currentStatus, intendedAction) => {
  return {
    submitted: ['approved', 'disputed', 'paid'],
    approved: ['paid', 'disputed', 'unapprove'],
    disputed: ['approved_after_dispute', 'paid', 'undispute'],
    paid: [],
    approved_after_dispute: ['paid', 'unapprove'],
  }[currentStatus].includes(intendedAction)
}

const InvoiceBuyerActionPanel = ({ children, invoice }) => {
  const [unapproveInvoice] = useUnapproveInvoiceMutation()
  const [approveInvoiceAfterDispute] = useApproveInvoiceAfterDisputeMutation()
  const [markInvoicePaid] = useMarkInvoicePaidMutation()

  const { purchasingEnvironment } = usePurchasing()

  return (
    <>
      {shouldShowForStatusAction(invoice.status, 'approved_after_dispute') && (
        <Button
          size="large"
          fullWidth
          color="lightGreen"
          style={{ marginBottom: 8 }}
          onClick={() => approveInvoiceAfterDispute(invoice)}
        >
          Approve for Payment
        </Button>
      )}

      {shouldShowForStatusAction(invoice.status, 'unapprove') && (
        <Button
          size="large"
          fullWidth
          color="yellow"
          style={{ marginBottom: 8 }}
          onClick={() => unapproveInvoice(invoice)}
        >
          Unapprove Invoice
        </Button>
      )}

      {shouldShowForStatusAction(invoice.status, 'paid') && (
        <Button
          size="large"
          fullWidth
          color="lightGreen"
          style={{ marginBottom: 8 }}
          onClick={() => markInvoicePaid(invoice)}
        >
          Mark Paid
        </Button>
      )}

      {/* {shouldShowForStatusAction(invoice.status, 'disputed') && (
        <Button
          size="large"
          fullWidth
          color="orange"
          style={{ marginBottom: 8 }}
          href={`/invoices/${invoice.id}/dispute`}
        >
          Dispute Invoice
        </Button>
      )} */}

      {/* {shouldShowForStatusAction(invoice.status, 'undispute') && (
        <Button
          size="large"
          fullWidth
          color="orange"
          style={{ marginBottom: 8 }}
          onClick={() => undisputeInvoice(invoice)}
        >
          Cancel Dispute
        </Button>
      )} */}

      <MessageSupplierModal
        environmentId={purchasingEnvironment}
        subject={`Re: Invoice ${invoice.id}`}
        supplier={invoice.supplier}
        trigger={props => (
          <Button
            color="white"
            fullWidth
            startIcon={<MessageIcon />}
            {...props}
          >
            Contact Supplier
          </Button>
        )}
      />

      {children}
    </>
  )
}

export default InvoiceBuyerActionPanel
